<template>
  <div id="obitos" class="row">
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs"
        v-model="tabsActive"
      >
        <b-tab title="Lista" active @click="buscarDadosDaLista()">
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="col-md-12">
              <div class="info-table">
                <div class="info-table-item">
                  <Subtitle
                    @exibirVermelhos="handleExibirVermelhos"
                    @exibirVerdes="handleExibirVerdes"
                    :setRed="setRed"
                    @resetarNome="setRed = false"
                  ></Subtitle>
                </div>
                <div class="info-table-item">
                  <download-files
                    :callback-pdf="generatePdf"
                    :data="displayedCadastros"
                    :fields="dataFields"
                    name="obitos"
                  >
                  </download-files>
                </div>
              </div>
              <tabela-cadastros
                ref="table"
                :cadastros="displayedCadastros"
                :loading="loadingLista"
                @filterSearch="filterSearch($event)"
              ></tabela-cadastros>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import * as Functions from './functions'
import TabelaCadastros from './TabelaCadastros.vue'
import { dataFields } from './utils.js'
import TitleTag from '@/components/TitleTag.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import utils from '@/mixins/utils.js'

export default {
  name: 'Obitos',
  components: {
    PulseLoader,
    Loader,
    Subtitle,
    TabelaCadastros,
    TitleTag,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      equipe: null,
      tabsActive: 0,
      cadastros: [],
      loadingLista: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      dataFields: {
        ...dataFields,
      },
      cadastrosOriginais: [],
      setRed: false,
      filterSearchTable: false,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Habilita os filtros vermelho/verde
     *
     * @param {Boolean} vermelho
     * @param {Boolean} verde
     */
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
    },

    /**
     * Atualiza o filtro para exibir registros classificados como vermelhos.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
      }
    },

    /**
     * Atualiza o filtro para exibir registros classificados como verdes.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },

    /**
     * Buscar dados
     */
    async buscarDadosDaLista() {
      if (this.cadastros.length === 0) {
        try {
          this.loadingLista = true

          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = equipe
          }

          let response = await Functions.getCadastrosIndividuaisPorMicroArea(
            this.$store.state.cod_ibge,
            this.equipe.ine_esf_eap,
            this.$store.state.micro_area
          )
          if (response) {
            this.cadastros = response
            this.cadastrosOriginais = response
            this.filtros(true, false)
            this.setRed = true
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loadingLista = false
        }
      }
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.$store.state.micro_area
      )
    },

    /**
     * Inicializa os dados
     */
    init() {
      this.buscarDadosDaLista()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style></style>
